module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/059-gabon-65a4bfa88b7e3ea73ae2f8b8521013fb.svg";